import ConfigurationList from './ConfigurationList';

export default ConfigurationList;
